const fetchData = (uuid, $this) => {
  const url = 'https://ibpp.com.br/api/associados/'
  const endpoint = `${url}${uuid}`

  return new Promise((resolve, reject) => {
    $this.$http
      .get(endpoint)
      .then(res => resolve(res.data))
      .catch(err => reject(err))
  })
}

const getIBPPUserData = (args = {}, $this) => {
  $this.formData['incomingPartnerName'].value = 'ibpp'

  if ('uuid' in args && args.uuid !== undefined) {
    const { uuid } = args

    $this.fn_SHOW_PROGRESS()
    fetchData(uuid, $this)
      .then((res) => {
        $this.formData['user.contactPhone'].value = res.contactPhone
        $this.formData['user.email.first'].value = res.email
        $this.formData['user.email.second'].value = res.email
        $this.formData['user.gender'].value = res.gender
        $this.formData['user.name'].value = res.name
        $this.formData['displayName'].value = res.displayName
        $this.formData.crm.value = res.crm
        $this.formData.uf.value = $this.formData.uf.options.find(uf => uf.name === res.uf).id
      })
      .finally(() => {
        $this.fn_HIDE_PROGRESS()
        $this.queryCrm()
      })
  }
}

const getIBPPLogin = (args = {}, $this) => {
  if ('uuid' in args && args.uuid !== undefined) {
    const { uuid } = args

    $this.fn_SHOW_PROGRESS()
    fetchData(uuid, $this)
      .then((res) => {
        $this.form.user.value = res.email
      })
      .finally($this.fn_HIDE_PROGRESS)
  }
}

export { getIBPPUserData, getIBPPLogin }
